export default "__VITE_ASSET__l9XfoEcm__"